import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 17px;
    padding-right: 17px;
    background-color: ${colors.grayFour};
    border: 1px solid ${colors.lightGrey};
    border-left: 0;
    border-bottom: 0;
    border-right: 0;
    height: 42px;
    cursor: pointer;

    & .filter-title {
      font-size: 15px;
      line-height: 18px;
      color: ${colors.darkGray};
      font-weight: 400;
      text-transform: uppercase;
    }

    & .filter-icon {
      -webkit-transition: -webkit-transform 0.3s linear;
      -ms-transition: -ms-transform 0.3s linear;
      transition: transform 0.3s ease-in-out;
      -webkit-transform: translate3d(0, 0, 0);
      -moz-transform: translate3d(0, 0, 0);
      -ms-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);

      path {
        stroke: ${colors.borderSelect};
      }
    }
  }

  .filter-content {
    height: 100%;
    overflow: auto;
    transition: max-height 0.3s linear;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    padding-top: 21px;
    padding-bottom: 21px;

    & .filter-sort {
      margin-left: 20px;
      margin-right: 20px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      & .filter-sort-icon {
        cursor: pointer;
        padding-bottom: 5px;

        path {
          fill: ${colors.darkGray};
        }
      }

      & .filter-sort-icon--selected {
        border-bottom: 2px solid ${colors.borderSelect};
      }
    }
  }

  .filter-content-container {
    height: 100%;
    overflow: hidden;
    transition: max-height 0.3s linear;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  .filter-item {
    display: flex;
    justify-content: space-between;
    padding-left: 19px;
    padding-right: 19px;

    &--radio:not(:last-of-type) {
      margin-bottom: 14px;
    }

    > .label {
      max-width: 85%;
    }

    & .number {
      font-size: 15px;
      line-height: 18px;
      color: ${colors.blackThree};
    }
  }

  .filter-see-more {
    text-align: center;
    text-decoration: underline;
    text-transform: lowercase;
    margin: 12px;
    cursor: pointer;
  }
`;

const svgStyle = {
  width: 32
};

export { Wrapper, svgStyle };



// WEBPACK FOOTER //
// ./src/components/ComboFilter/style.js